import { ApplicationListActions } from './actions';
import { GLOBAL_RESOURCES } from 'src/constants';
import { useInstanceEvaluations } from 'src/hooks';

/**
 * Shared by every consumer of an application list's data (the page and its
 * breadcrumb) so they all gate on the exact same authorization check.
 */
export const useApplicationListAuthorization = (applicationListId?: string) =>
  useInstanceEvaluations({
    actions: [...Object.values(ApplicationListActions)],
    requiredActions: [ApplicationListActions.READ],
    resource: {
      id: applicationListId!,
      type: GLOBAL_RESOURCES.TM_APPLICATION_LIST,
    },
  });
